/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import CurateTabs from 'app/components/Curate/CurateTabs.jsx';
import FeedEditorTabs from 'app/components/EditorComponents/FeedEditorTabs.jsx';
import CreateFeed from 'app/components/CreateFeed/CreateFeed.jsx';
import setInputDefaults from 'app/mixins/InputDefaultsModule.js';
import FormUtilityMixin from 'app/mixins/FormUtilityMixin.js';
import Loading from 'app/components/common/Loading.jsx';
import TwitterInputConfigPanel from 'app/components/EditorComponents/TwitterInputConfigPanel.jsx';
import PinterestConfigPanel from 'app/components/EditorComponents/PinterestConfigPanel.jsx';
import InstagramConfigPanel from 'app/components/EditorComponents/InstagramConfigPanel.jsx';
import FacebookPageConfigPanel from 'app/components/EditorComponents/FacebookPageConfigPanel.jsx';
import TikTokInputConfigPanel from 'app/components/EditorComponents/TikTokInputConfigPanel.jsx';
import EditorButtons from 'app/components/EditorComponents/EditorButtons.jsx';
import FeedProvider from 'app/redux/Providers/FeedProvider.jsx';
import Utilities from 'app/utility/Utilities.js';
import { compose } from 'redux';
import * as _ from 'underscore';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class CurateFeedsNew extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            route: {
                id: 0,
                name: 'My Curated Route',
                type: this.props.app.config.constants.R_CURATE_BASIC,
                activeFlag: true,
                inputs: [],
                socials: [],
                options: {
                    filters: {},
                    tracking: '',
                    shortenerId: ''
                }
            },
            newInput: {},
            errors: null,
            buttonActive: false,
            showOrientation: true,
            searchErrors: null,
            createInput: false
        };

        this.createInput = this.createInput.bind(this);
        this.feedRemoval = this.feedRemoval.bind(this);
        this.saveCuratedFeed = this.saveCuratedFeed.bind(this);
        this.storeRouteState = this.storeRouteState.bind(this);
        this.onPinterestClick = this.onPinterestClick.bind(this);
        this.cancelAction = this.cancelAction.bind(this);

    }

    componentDidMount() {

        this.props.restorePeristedData("curatedFeeds", null, this);

        // redirect if input is null
        if (_.isEmpty(this.state.newInput) && this.props.router.location.pathname.match('configure')) {
            this.props.router.navigate('/share/curate/feeds/new');
        }

        this.props.deleteApiError(['FEED_SEARCH', 'FEED_VALIDATE', 'INPUT_VALIDATE']);

    }

    componentWillUnmount() {

        // a refused save's reason would show wherever a feed is next searched for
        this.props.deleteApiError(['CURATION_INPUT_CREATE', 'CURATION_ROUTE_CREATE']);

    }

    componentDidUpdate(prevProps, prevState) {
        let errors = [];

        errors = this.props.getApiErrors(['FEED_SEARCH', 'FEED_VALIDATE', 'INPUT_VALIDATE']);
		if (errors.length && this.state.searchErrors === null) {
            this.setState({
                newInput: {},
                createInput: false,
                searchErrors: errors[0]
            });
		}

        if (this.props.app.configLoaded && this.props.app.userLoaded &&
            (prevProps && prevProps.app.loading.CURATION_ID === true && this.props.app.loading.CURATION_ID === false)) {
            if (this.props.router.query !== null && this.props.router.query.state) {
                this.props.authReturnHandler({
                    path: '/share/curate/feeds/new'
                },
                this.createInput);
            }

        }

        if (prevProps && ((prevProps.app.loading.FEED_VALIDATE === true && this.props.app.loading.FEED_VALIDATE === false) ||
            (prevProps.app.loading.INPUT_VALIDATE === true && this.props.app.loading.INPUT_VALIDATE === false))) {
            if (this.props.automatedRoutes.validInputs.length) {
                for (let i = 0; i < this.props.automatedRoutes.validInputs.length; ++i) {
                    if (this.props.automatedRoutes.validInputs[i].id == this.state.newInput.id) {
                        let nextInput = Utilities.deepClone(this.state.newInput);

                        if (nextInput.valid === undefined || nextInput.valid === null) {
                            nextInput.valid = true;
                        }

                        this.setState({
                            newInput: nextInput
                        }, () => {
                            this.saveCuratedFeed();
                        });
                        break;
                    }
                }
            }
        }

        if ((prevProps.app.loading.CURATION_INPUT_CREATE === true && this.props.app.loading.CURATION_INPUT_CREATE === false) ||
            (prevProps.app.loading.CURATION_ROUTE_CREATE === true && this.props.app.loading.CURATION_ROUTE_CREATE === false)) {
            let refusals = this.props.getApiErrors(['CURATION_INPUT_CREATE', 'CURATION_ROUTE_CREATE']);
            if (refusals.length) {
                if (refusals[0].errors !== undefined && refusals[0].errors.perms !== undefined) {
                    this.props.showUpgradeModal(this.props.closeAllModals, null, refusals[0], 'curate_error');
                }
                // a refused save stays to be tried again: a feed's settings as they were, a feed
                // found by search searched for again
                this.setState({
                    newInput: this.props.router.location.pathname.match('configure') ? this.state.newInput : {},
                    createInput: false,
                    errors: refusals[0]
                });
                return;
            }

            // remove onboarding flag in case someone's first action in dlvr.it is a manual post
            let onboarding = (typeof (Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;
            if (onboarding !== null) {
                if (this.props.recordEvent) {
                    this.props.recordEvent({
                        pub_id: this.props.user.detail.id,
                        event_name: 'Onboarding - Complete',
                        event_data: {
                            'method': 'Curation'
                        }
                    });
                }
                window.localStorage.removeItem('onboarding');
            }
            this.props.router.navigate('/share/curate/items');
        }

    }

    createInput(input) {

        let constants = this.props.app.config.constants,
            buttonActive = this.state.buttonActive,
            username = input.username,
            createInput = false;

        setInputDefaults.apply(this, [input, input.type, this.props.user.perms, constants.R_CURATE_BASIC]);

        if (this.props.curation.route.id) {
            input.rID = this.props.curation.route.id;
        }

        if (input.type == constants.INPUT_TYPE_FEED && input.subtype === undefined) {
            buttonActive = false;
            createInput = true;
        } else if (input.subtype && input.subtype == constants.INPUT_SUBTYPE_PINTEREST) {
            buttonActive = true;
            this.props.router.navigate('/share/curate/feeds/new/configure');
        } else if (input.type == constants.INPUT_TYPE_INSTAGRAM || input.type == constants.INPUT_TYPE_INSTAGRAM_BUSINESS) {
            input.name = username;
            input.valid = true;
            createInput = true;
            buttonActive = true;
        } else if (input.type == constants.INPUT_TYPE_TWITTER) {
            input.attrs.user_name = "@" + username;
            input.name = "@" + username + " Timeline";
            buttonActive = true;
            input.valid = true;
            createInput = true;
        } else if (input.type == constants.INPUT_TYPE_FACEBOOK_PAGE) {
			input.name = input.username + " Posts";
            input.valid = true;
            buttonActive = true;
            createInput = true;
		} else if (input.type == constants.INPUT_TYPE_TIKTOK) {
			input.name = input.username + " Posts";
            input.valid = true;
            buttonActive = true;
            createInput = true;
		}

        if (this.props.isFreeUser()) {
            input.postLimit = 10;
        }

        this.setState({
            newInput: input,
            buttonActive,
            createInput
        }, () => {
            this.props.resetAuthState();
            if (this.state.createInput) {
                this.props.validateInput(this.state.newInput, this.state.newInput.id);
            }
        });

    }

    feedRemoval() {
        this.setState({
            newInput: {}
        });

        this.props.deleteApiError(['FEED_SEARCH', 'FEED_VALIDATE', 'INPUT_VALIDATE']);

    }

    saveCuratedFeed(e) {

        if (e) {
            e.preventDefault();
        }

        if (this.props.curation.route.id) {
            // for social feeds there's a race with the authHandler
            // if rID is -1 set it properly
            let newInput = Utilities.deepClone(this.state.newInput)
            if (newInput.rID === -1) {
                newInput.rID = this.props.curation.route.id;
            }
            this.props.createCurationInput(newInput);
        } else {
            this.state.route.inputs = [this.state.newInput];
            this.props.createCurationRoute(this.state.route);
        }

    }

    storeRouteState() {

        this.props.persistData("curatedFeeds", this.state);

    }

    onPinterestClick() {
        let constants = this.props.app.config.constants;

        this.createInput({
            type: constants.INPUT_SUBTYPE_PINTEREST
        });
    }

    cancelAction(e) {

        e.preventDefault();

        this.props.router.navigate('/share/curate/items');

    }

    render() {

        let canAddFeeds = (Object.keys(this.state.newInput).length) ? false : true,
            feeds = (Object.keys(this.state.newInput).length) ? [this.state.newInput] : [],
            tabs = (
                <CurateTabs
                    {...this.props}
                    active="curate-feeds-new"
                    recordPath={this.props.recordPath}/>
            ),
            body = (
                <CreateFeed
                    {...this.props}
                    onFeedSelect={this.createInput}
                    onFeedRemoval={this.feedRemoval}
                    initialFeeds={feeds}
                    canAddFeeds={canAddFeeds}
                    onSocialClick={this.storeRouteState}
                    onSubtypeClick={this.onPinterestClick}
                    recordPath={this.props.recordPath}
                    context='curate'
                    searchErrors={this.state.searchErrors} />
              ),
              controls = null,
              main = null,
              constants = this.props.app.config.constants,
              buttonLabel = "Save",
              inputType = 100,
              feedLabel = 'Feed',
              buttonAction = () => {},
              editorButtons = null;


        if (this.state.newInput.type) {
            inputType = this.state.newInput.type;
            if (this.state.newInput.subtype) {
                inputType = this.state.newInput.subtype;
            }
            feedLabel = this.state.newInput.name;
        }

        controls = (
            <FeedEditorTabs
                {...this.props}
                inputType={inputType}
                feedLabel={feedLabel}
                showSocial={false}
                showOrientation={true}
                feedType='curated' />
        );

        if (this.props.router.location.pathname.match('configure')) {
            if (_.isEmpty(this.state.newInput)) {
                return null;
            }

            buttonAction = this.saveCuratedFeed;

            if (this.state.newInput.type == constants.INPUT_TYPE_TWITTER) {
                body = (
                    <TwitterInputConfigPanel
                        {...this.props}
                        input={this.state.newInput}
                        changeHandler={FormUtilityMixin.requestChange.bind(this)}
                        errors={this.state.errors}
                        routeType={constants.R_CURATE_BASIC}
                        statePath="newInput"/>
                );
            }
            if (this.state.newInput.subtype && this.state.newInput.subtype == constants.INPUT_SUBTYPE_PINTEREST) {
                body = (
                    <PinterestConfigPanel
                        {...this.props}
                        input={this.state.newInput}
                        changeHandler={FormUtilityMixin.requestChange.bind(this)}
                        errors={this.state.errors}
                        routeType={constants.R_CURATE_BASIC}
                        statePath="newInput" />
                );
            }

            if (this.state.newInput.type == constants.INPUT_TYPE_INSTAGRAM ||
                this.state.newInput.type == constants.INPUT_TYPE_INSTAGRAM_BUSINESS) {
                body = (
                    <InstagramConfigPanel
                        {...this.props}
                        input={this.state.newInput}
                        changeHandler={FormUtilityMixin.requestChange.bind(this)}
                        errors={this.state.errors}
                        routeType={constants.R_CURATE_BASIC}
                        statePath="newInput" />
                );
            }

            if (this.state.newInput.type == constants.INPUT_TYPE_FACEBOOK_PAGE) {
                body = (
                    <FacebookPageConfigPanel
                        {...this.props}
                        input={this.state.newInput}
                        changeHandler={FormUtilityMixin.requestChange.bind(this)}
                        errors={this.state.errors}
                        routeType={constants.R_CURATE_BASIC}
                        statePath="newInput" />
                );
            }

            if (this.state.newInput.type == constants.INPUT_TYPE_TIKTOK) {
                body = (
                    <TikTokInputConfigPanel
                        {...this.props}
                        input={this.state.newInput}
                        changeHandler={FormUtilityMixin.requestChange.bind(this)}
                        errors={this.state.errors}
                        routeType={constants.R_CURATE_BASIC}
                        statePath="newInput" />
                );
            }

            editorButtons = (
                <EditorButtons
                    cancelAction={this.cancelAction}
                    saveLabel={buttonLabel}
                    saveActive={this.state.buttonActive}
                    saveAction={buttonAction} />
            );

        }

        if (this.state.createInput || this.props.app.loading.CURATION_LIST) {
            main = (
                <Loading />
            );
        } else {
            main = (
                <div>
                    {controls}
                    {body}
                    {editorButtons}
                </div>
            );
        }

        return <Content header={tabs} main={main} />;

    }

};

CurateFeedsNew.displayName = "CurateFeedsNew";

CurateFeedsNew.defaultProps = {
    selected: 'items'
};

const enhance = compose(
    ComponentWithContext,
    FeedProvider
);

export default enhance(CurateFeedsNew);
